import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { authAction } from '../Slice/auth';
import { AppConfig } from '../../constants/AppConfig';
import { toast } from 'react-toastify';

export const baseQuery = (options) => {
    return fetchBaseQuery({
        baseUrl: AppConfig.CONFIGURATION.API_URL,
        fetchFn: async (...args) => {
            return fetch(...args);
        },
        prepareHeaders: (header) => {
            const { isAuthorizationApi = true } = options;
            if (!isAuthorizationApi) return header;
            const token = localStorage.getItem('token');
            if (!token) {
                header.set('X-API-KEY', `Api-Key ${AppConfig.CONFIGURATION.APP_KEY}`);
            }
            else {
                header.set('Authorization', `Token ${token}`);
                header.set('X-API-KEY', `Api-Key ${AppConfig.CONFIGURATION.APP_KEY}`);
            }
            // header.set('Authorization', `Api-Key ${AppConfig.CONFIGURATION.APP_KEY}`);
            return header;
        },
    });
};

export const baseApiQuery = async (args, api, extraOption = {}) => {
    const apiCopy = { ...api };
    const { dispatch } = apiCopy;

    try {
        const query = baseQuery(extraOption);
        const result = await query(args, api, extraOption);
        if (result.error) {
            const { error } = result;
            if (error.status === 401) {
                localStorage.getItem('token');
                dispatch(authAction.logout());
                toast.error('Your session has expired. please log in again.')
            } else if (error.status === 500) {
                toast.error('Please try after sometimes.')
            }
        }
        return result;
    } catch (error) {
        console.log("🚀 ~ constbaseApiQuery:BaseApiQueryType= ~ error:", error)
        throw error;
    }
};
